import React, { useState, useEffect, useRef } from "react";

import AsyncSelect from "react-select/async";

import "./locationsearch.css";

import { customComponents, customStyles } from "./ReactSelectCustom";

import { toast } from "react-toastify";
import { getDestinationSuggestionsApi } from "../../api/publicApi";

const MAX_INPUT_LENGTH = 100;

const LocationSearch = ({ searchCriteria, setSearchCriteria, setErrors }) => {
  const locationsearchRef = useRef(null);

  const selectedOption = addLabelValue({
    ...searchCriteria.location,
    ...searchCriteria.propertyDetails,
  });

  const [inputValue, setInputValue] = useState("");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [hasInputError, setHasInputError] = useState(false);

  const [defaultOptions, setDefaultOptions] = useState([]);

  const loadOptions = (inputValue, callback) => {
    if (!inputValue) {
      callback([]);
      return;
    }

    if (inputValue.length > MAX_INPUT_LENGTH) {
      setHasInputError(true);
      callback([]);
      return;
    } else {
      setHasInputError(false);
    }

    getDestinationSuggestionsApi(inputValue)
      .then((response) => {
        const suggestions = response.data.suggestions || [];

        const formattedSuggestions = suggestions.map((suggestion) => {
          return {
            ...suggestion,
            value: suggestion.label,
          };
        });

        callback(formattedSuggestions);
      })
      .catch(() => {
        toast.error("Failed to fetch search suggestions.");
        callback([]);
      });
  };

  const handleChange = async (option = {}) => {
    setErrors((prev) => ({ ...prev, location: null }));

    const payload = {
      propertyDetails: {
        propertyId: option.propertyId || null,
        propertyName: option.propertyId ? option.label : null,
      },
      location: {
        city: option.city || null,
        district: option.district || null,
        province: option.province || null,
        country: option.country || "Sri Lanka",
        latitude: option.latitude || null,
        longitude: option.longitude || null,
        label: option.label || null,
      },
    };
    setSearchCriteria((prev) => ({
      ...prev,
      ...payload,
    }));
  };

  const onMenuOpenHandler = () => {
    setIsMenuOpen(true);
  };

  useEffect(() => {
    if (isMenuOpen) {
      if (window.location.hash === "#overlay") {
        window.history.replaceState(null, null, "#overlay");
      } else {
        window.history.pushState(null, null, "#overlay");
      }
      // } else {
      //   window.history.replaceState(
      //     null,
      //     null,
      //     window.location.pathname + window.location.search
      //   );
    }

    if (isMenuOpen) return;

    if (inputValue) {
    }
  }, [isMenuOpen]);

  useEffect(() => {
    const handleHashChange = () => {
      if (window.location.hash !== "#overlay" && isMenuOpen) {
        setIsMenuOpen(false);
        locationsearchRef.current.blur();
      }
    };
    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [isMenuOpen]);

  useEffect(() => {
    if (defaultOptions.length > 0 || !selectedOption.value) return;

    getDestinationSuggestionsApi(selectedOption.value ?? "")
      .then(async (response) => {
        // wait for 3 seconds

        const suggestions = response.data.suggestions || [];

        const formattedSuggestions = suggestions.map((suggestion) => {
          return {
            ...suggestion,
            value: suggestion.label,
          };
        });

        // set the first option as the selected option

        const firstSuggestion = formattedSuggestions[0] || {};

        const payload = {
          propertyDetails: {
            propertyId: firstSuggestion.propertyId || null,
            propertyName: firstSuggestion.propertyId ? firstSuggestion.label : null,
          },
          location: {
            city: firstSuggestion.city || null,
            district: firstSuggestion.district || null,
            province: firstSuggestion.province || null,
            country: firstSuggestion.country || "Sri Lanka",
            latitude: firstSuggestion.latitude || null,
            longitude: firstSuggestion.longitude || null,
            label: firstSuggestion.label || null,
          },
        };

        setSearchCriteria((prev) => ({
          ...prev,
          ...payload,
        }));

        setDefaultOptions(formattedSuggestions);
      })
      .catch(() => {
        toast.error("Failed to fetch search suggestions.");
      });
  }, [selectedOption.value]);

  const handleInputChange = (input, { action }) => {
    setInputValue(input);

    if (input.length > MAX_INPUT_LENGTH) {
      setHasInputError(true);
    } else {
      setHasInputError(false);
    }

    return input;
  };

  const noOptionsMessageHandler = () => {
    if (hasInputError) return `Maximum ${MAX_INPUT_LENGTH} characters allowed`;
    if (!inputValue) return "Type to search for locations";

    return "No locations found";
  };

  return (
    <AsyncSelect
      ref={locationsearchRef}
      value={selectedOption.value ? selectedOption : null}
      onChange={handleChange}
      inputValue={inputValue}
      onInputChange={handleInputChange}
      blurInputOnSelect={true}
      defaultOptions={defaultOptions}
      cacheOptions
      loadOptions={loadOptions}
      placeholder="Search Location"
      components={customComponents}
      styles={customStyles}
      onMenuOpen={onMenuOpenHandler}
      onMenuClose={() => setIsMenuOpen(false)}
      className="location-search-select"
      noOptionsMessage={noOptionsMessageHandler}
    />
  );
};

export default LocationSearch;

function addLabelValue(obj) {
  // Initialize label and value to empty strings
  let label = "";
  let value = "";

  // Determine label and value based on the properties of the object
  if (obj.propertyName) {
    label = obj.propertyName;
    value = obj.propertyName;
  } else if (obj.city) {
    label = `${obj.city}, ${obj.country}`;
    value = `${obj.city}, ${obj.country}`;
  } else if (obj.district) {
    label = `${obj.district} District, ${obj.country}`;
    value = `${obj.district} District, ${obj.country}`;
  } else if (obj.province) {
    label = `${obj.province} Province, ${obj.country}`;
    value = `${obj.province} Province, ${obj.country}`;
  } else {
    label = obj.country;
    value = obj.country;
  }

  // Add label and value to the object
  obj.label = label;
  obj.value = value;

  return obj;
}
